"use strict";

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _inherits = require("/app/front/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/app/front/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/app/front/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/app/front/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Types of errors that the UALError class can represent
 */

var UALErrorType;

(function (UALErrorType) {
  UALErrorType["UAL"] = "UAL";
  UALErrorType["Login"] = "Login";
  UALErrorType["Logout"] = "Logout";
  UALErrorType["Signing"] = "Signing";
  UALErrorType["Validation"] = "Validation";
  UALErrorType["Initialization"] = "Initialization";
  UALErrorType["DataRequest"] = "DataRequest";
  UALErrorType["Unsupported"] = "Unsupported";
})(UALErrorType = exports.UALErrorType || (exports.UALErrorType = {}));
/**
 * Base error class for UAL errors.
 */


var UALError = /*#__PURE__*/function (_Error) {
  _inherits(UALError, _Error);

  var _super = _createSuper(UALError);

  /**
   * @param message Message describing the error
   *
   * @param source The name of the authenticator that is the source of the error
   *
   * @param cause The underlying Error (if any) that resulted in the current one being thrown
   */
  function UALError(message, type, cause, source) {
    var _this;

    _classCallCheck(this, UALError);

    _this = _super.call(this, message);
    _this.type = type;
    _this.cause = cause;
    _this.source = source;
    return _this;
  }

  return UALError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.UALError = UALError;